"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaygreenBrand = exports.StripeBrand = void 0;
var StripeBrand;
(function (StripeBrand) {
    StripeBrand["Visa"] = "visa";
    StripeBrand["Mastercard"] = "mastercard";
    StripeBrand["Amex"] = "amex";
})(StripeBrand || (exports.StripeBrand = StripeBrand = {}));
var PaygreenBrand;
(function (PaygreenBrand) {
    PaygreenBrand["BankCard"] = "bank_card";
})(PaygreenBrand || (exports.PaygreenBrand = PaygreenBrand = {}));
exports.default = { StripeBrand: StripeBrand, PaygreenBrand: PaygreenBrand };
//# sourceMappingURL=PaymentCard.js.map